import { TABLE_UNMOUNT } from '../Table/tableActions';
import {
    PAYOUTS_FAILURE,
    PAYOUTS_LOAD,
    PAYOUTS_SUCCESS,
    UPLOAD_PAYOUT_BATCH_LOAD,
    UPLOAD_PAYOUT_BATCH_SUCCESS,
    UPLOAD_PAYOUT_BATCH_FAILURE
} from './payoutsActions';
import {
    get,
    isEqual
} from 'lodash';
import { createSelector } from 'reselect';
import { getEntityByName } from '../appEntities';

export default function reducer(state = {}, action = {}) {
    let newState;

    switch (action.type) {
        case TABLE_UNMOUNT:
            newState = {
                ...state,
                payouts: []
            };

            return isEqual(state, newState) ? state : newState;

        case PAYOUTS_LOAD:
            newState = {
                ...state,
                payouts: [],
                error: null,
                loading: true
            };

            return isEqual(state, newState) ? state : newState;

        case PAYOUTS_SUCCESS:
            newState = {
                ...state,
                payouts: action.payouts,
                count: action.count,
                loading: false,
                pages: action.pages,
                hasMore: action.hasMore,
                offset: action.offset,
                limit: action.limit
            };

            return isEqual(state, newState) ? state : newState;

        case PAYOUTS_FAILURE:
            newState = {
                ...state,
                count: 0,
                error: action.error,
                loading: false,
                pages: 0
            };

            return isEqual(state, newState) ? state : newState;

        case UPLOAD_PAYOUT_BATCH_LOAD:
            newState = {
                ...state,
                batchUploadError: null,
                wasBatchUploadSuccessful: false,
                isBatchUploading: true
            };

            return isEqual(state, newState) ? state : newState;

        case UPLOAD_PAYOUT_BATCH_SUCCESS:
            newState = {
                ...state,
                wasBatchUploadSuccessful: true,
                isBatchUploading: false
            };

            return isEqual(state, newState) ? state : newState;

        case UPLOAD_PAYOUT_BATCH_FAILURE:
            newState = {
                ...state,
                batchUploadError: action.error,
                wasBatchUploadSuccessful: false,
                isBatchUploading: false
            };

            return isEqual(state, newState) ? state : newState;
        default:
            return state;
    }
}

export const getPayoutsEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'payouts')
);

export const getPages = createSelector(
    getPayoutsEntity,
    (entity) => get(entity, 'pages')
);

export const getCount = createSelector(
    getPayoutsEntity,
    (entity) => get(entity, 'count')
);

export const getIsPayoutsLoading = createSelector(
    getPayoutsEntity,
    (entity) => get(entity, 'loading')
);

export const getPayouts = createSelector(
    getPayoutsEntity,
    (entity) => get(entity, 'payouts')
);

export const getPayoutsError = createSelector(
    getPayoutsEntity,
    (entity) => get(entity, 'error')
);

export const getPayoutsErrorMessage = createSelector(
    getPayoutsError,
    (error) => get(error, 'message')
);

export const getHasMore = createSelector(
    getPayoutsEntity,
    (entity) => get(entity, 'hasMore')
);

export const getIsPayoutBatchUploading = createSelector(
    getPayoutsEntity,
    (entity) => get(entity, 'isBatchUploading')
);

export const getPayoutBatchError = createSelector(
    getPayoutsEntity,
    (entity) => get(entity, 'batchUploadError')
);

export const getPayoutBatchErrorMessage = createSelector(
    getPayoutBatchError,
    (error) => get(error, 'message')
);

export const getWasBatchUploadSuccessful = createSelector(
    getPayoutsEntity,
    (entity) => get(entity, 'wasBatchUploadSuccessful')
);
